// Test IDs for the authenticated workspace home page.

export const HOME = {
  page: "home-page",
  brandBlock: "home-brand-block",
  welcome: "home-welcome",
  card: (section) => `home-card-${section}`,
};
